import { EventNames } from '@iheartjane/tracking';

import type {
  SearchVirtualBudtenderProducts,
  SearchedMenuProducts,
  SearchedProducts,
  SharedSearchProperties,
} from '../event.types';

export const getVirtualBudtenderSearchEventDetails = ({
  store,
}: {
  store: { id: string | number; name: string };
}): Omit<SearchVirtualBudtenderProducts, keyof SharedSearchProperties> => ({
  event: EventNames.VirtualBudtenderResults,
  storeId: store.id.toString(),
  storeName: store.name,
  view: 'grid',
});

export const getMenuSearchEventDetails = ({
  store,
  view,
}: {
  store: { id: string | number; name: string };
  view: 'grid' | 'list';
}): Omit<SearchedMenuProducts, keyof SharedSearchProperties> => ({
  event: EventNames.SearchedMenuProducts,
  storeId: store.id.toString(),
  storeName: store.name,
  view,
});

export const getProductSearchEventDetails = ({
  cityState,
}: {
  cityState?: string;
}): Omit<SearchedProducts, keyof SharedSearchProperties> => ({
  event: EventNames.SearchedProducts,
  cityState: cityState || undefined,
});
